//import React, { useState, useEffect } from 'react';
import React, { useState, useEffect, useMemo } from "react";
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import { Modal } from '@mui/material';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function TrialBalanceReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [financialDate, setFinancialDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, companyName, permissions, username, token, logout } = useAuth();
    const [reportGeneratedTime, setReportGeneratedTime] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        setFinancialDate(getFormattedStartFinancialDate());
    }, [isAuthenticated, companyId, token, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };

    const getFormattedStartFinancialDate = () => {
        const monthStartFinancialDate = new Date();
        monthStartFinancialDate.setDate(1);
        return monthStartFinancialDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    const handleFinancialDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFinancialDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [isLoading, setIsLoading] = useState(false);

    const filteredDataItem = useMemo(() => {
        return dataItem;
    }, [dataItem]);

    const fetchTableData = async () => {
        setDataItem([]);
        setIsLoading(true);
        const now = new Date();
        const formattedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString(); // e.g., 10:45:23 AM

        setReportGeneratedTime(formattedDateTime);

        try {
            const branchId = 0;
            const response = await fetchData(
                "ReportApi",
                `/TrialBalanceDetails/${branchId}/${fromDate}/${toDate}/${financialDate}/${companyId}`,
                token
            );

            if (response.responseCode === "1111") {
                setDataItem(response.response_data);
            } else {
                console.warn("Unexpected response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching Trial Balance Details:", error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const [selectedAccount, setSelectedAccount] = useState(null); // For AccountName and other details

    useEffect(() => {
        fetchTableData();
    }, []);


    // const handleExportToExcel = () => {
    //     const now = new Date();
    //     const generatedDateTime =
    //         String(now.getDate()).padStart(2, '0') + '-' +
    //         String(now.getMonth() + 1).padStart(2, '0') + '-' +
    //         now.getFullYear() + ' ' +
    //         now.toLocaleTimeString();

    //     const headerRows = [
    //         ["Trial Balance"],
    //         [`As On ${toDate}`],
    //         [`Report Generated: ${generatedDateTime}`],
    //         [],
    //         ["Head", "Particulars", "Debit", "Credit"]
    //     ];

    //     const worksheet = XLSX.utils.aoa_to_sheet(headerRows);

    //     worksheet['!cols'] = [
    //         { wch: 15 },
    //         { wch: 30 },
    //         { wch: 15 },
    //         { wch: 15 }
    //     ];

    //     let currentHeadName = null;
    //     let rowIndex = headerRows.length;

    //     filteredDataItem.forEach((data) => {
    //         if (data.headName && data.headName !== currentHeadName) {
    //             currentHeadName = data.headName;
    //             XLSX.utils.sheet_add_aoa(worksheet, [[data.headName, "", "", ""]], { origin: `A${++rowIndex}` });
    //             rowIndex++;
    //         }

    //         const debit = parseFloat(data.TotalDebitSum || 0);
    //         const credit = parseFloat(data.TotalCreditSum || 0);

    //         XLSX.utils.sheet_add_aoa(worksheet, [[
    //             "",
    //             data.AccountName,
    //             debit,
    //             credit
    //         ]], { origin: `A${++rowIndex}` });

    //         // Apply number format for debit and credit cells:
    //         worksheet[`C${rowIndex}`].z = "0.00";  // 2 decimal places
    //         worksheet[`D${rowIndex}`].z = "0.00";
    //     });

    //     const totalDebit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalDebitSum || 0), 0);
    //     const totalCredit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalCreditSum || 0), 0);

    //     XLSX.utils.sheet_add_aoa(worksheet, [["Total", "", totalDebit, totalCredit]], { origin: `A${++rowIndex}` });

    //     worksheet[`C${rowIndex}`].z = "0.00"; // total debit format
    //     worksheet[`D${rowIndex}`].z = "0.00"; // total credit format

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Trial Balance");
    //     XLSX.writeFile(workbook, "TrialBalance.xlsx");
    // };

    const handleExportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Trial Balance");
        worksheet.views = [{ state: 'frozen', ySplit: 4 }];

        const now = new Date();
        const generatedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString();

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER SECTION
        worksheet.mergeCells('A1:D1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = 'Trial Balance';
        titleCell.font = { bold: true, size: 12 };
        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells('A2:D2');
        const dateCell = worksheet.getCell('A2');
        dateCell.value = `As On ${toDate}`;
        dateCell.font = { italic: true, size: 10 };
        dateCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.mergeCells('A3:D3');
        const generatedCell = worksheet.getCell('A3');
        generatedCell.value = `Report Generated: ${generatedDateTime}`;
        generatedCell.font = { size: 9 };
        generatedCell.alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerRow = worksheet.addRow(["Head", "Particulars", "Debit", "Credit"]);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
        });

        // 🔹 DATA SECTION
        let currentHeadName = null;
        let balRowStart = worksheet.rowCount + 1;

        filteredDataItem.forEach((data) => {
            if (data.headName && data.headName !== currentHeadName) {
                currentHeadName = data.headName;

                const headRow = worksheet.addRow([data.headName, "", "", ""]);
                headRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFCE5CD' }, // Light orange for Head
                    };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                });
            }

            const debit = parseFloat(data.TotalDebitSum || 0);
            const credit = parseFloat(data.TotalCreditSum || 0);

            const row = worksheet.addRow(["", data.AccountName, debit, credit]);
            row.eachCell((cell, colNum) => {
                cell.border = thinBorder;
                if (colNum === 3 || colNum === 4) {
                    cell.alignment = { horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left' };
                }
            });
        });

        // 🔹 TOTAL ROW
        const totalDebit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalDebitSum || 0), 0);
        const totalCredit = filteredDataItem.reduce((sum, data) => sum + parseFloat(data.TotalCreditSum || 0), 0);

        const totalRow = worksheet.addRow(["Total", "", totalDebit, totalCredit]);
        totalRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF4CCCC' }, // Light pink for total
            };
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
            if (cell.col === 3 || cell.col === 4) {
                cell.numFmt = '#,##0.00';
            }
        });

        // 🔹 ADJUST COLUMN WIDTHS
        worksheet.columns = [
            { width: 20 }, // Head
            { width: 40 }, // Particulars
            { width: 15 }, // Debit
            { width: 15 }, // Credit
        ];

        // 🔹 EXPORT FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Trial_Balance_AsOn_${toDate.replace(/\//g, '-')}.xlsx`
        );
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    };

    //Customer Ledger  
    const [CustomerLedgermodel, setCustomerLedgermodal] = useState(false);
    const [CustomerLedgerFilteredData, setCustomerLedgerFilteredData] = useState([]);

    const openCustomerLedgermodal = async () => {
        console.log('Opening route data modal');
        //await handlePendingBillClick();
        //handleCustomerLedgerClick();
        setCustomerLedgermodal(true);
    };


    const handleCustomerLedgerClick = async (headid, accountName) => {
        setSelectedAccount({ headid, accountName }); // Store the clicked account's details
        setCustomerLedgerFilteredData([]); // Clear previous data
        try {
            const response = await fetchData(
                "ReportApi",
                `/Ledger/${companyId}/${headid}/${fromDate}/${toDate}`,
                token
            );
            if (response.responseCode === "1111") {
                setCustomerLedgerFilteredData(response.response_data);
                setCustomerLedgermodal(true); // Open modal
            } else {
                console.error("Invalid response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching ledger data:", error);
        }
    };

    const closeCustomerLedgerModal = () => {
        console.log('Closing modal');
        setCustomerLedgermodal(false);
    };


    const handleExportCashBookExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Cash Book');
        worksheet.views = [{ state: 'frozen', ySplit: 2 }];

        let bal = 0;

        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedAccount?.accountName || 'Cash Book';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 Header Title Row
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Cash Book for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // 🔹 Column Headers
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green header
            };
        });

        // 🔹 Data Rows
        CashBookilteredData.forEach((rowData) => {
            let rowValues;

            if (['Opening Balance', 'Closing Balance', 'Total'].includes(rowData.description1)) {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : '',
                ];
            } else {
                rowValues = [
                    formatDate(rowData.billdate),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData),
                ];
            }

            const row = worksheet.addRow(rowValues);

            // 🔸 Style total or closing rows differently
            if (['Closing Balance', 'Total'].includes(rowData.description1)) {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                    cell.font = { bold: true };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
                });
            } else {
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        // 🔹 Adjust column widths
        worksheet.columns = [
            { width: 15 },
            { width: 35 },
            { width: 15 },
            { width: 15 },
            { width: 20 },
        ];

        // 🔹 Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedLabel = customerLabel.replace(/[^\w]/g, '_');
        saveAs(
            new Blob([buffer]),
            `Cash_Book_${sanitizedLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    // const handleExportCashBookExcel = () => {
    //     const excelData = [];
    //     let copbal = 0; // Cumulative opening balance for credit
    //     let dopbal = 0; // Cumulative opening balance for debit
    //     let bal = 0;    // Running balance

    //     // Helper function to compute balance
    //     const computeBalance = (data) => {
    //         // if (data.description1 === 'Opening Balance') {
    //         //     bal = 0; // Reset balance for opening balance
    //         // } else 
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             // Add debit to balance
    //             if (data.debit) {
    //                 bal += Math.abs(data.debit);
    //             }
    //             // Subtract credit from balance
    //             if (data.credit) {
    //                 bal -= Math.abs(data.credit);
    //             }
    //         }

    //         // Return balance string with "Dr" or "Cr"
    //         //data.description1 !== 'Opening Balance' &&
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };

    //     // Ensure selectedCustomer is handled properly
    //     //const customerLabel = selectedChildOption ? selectedChildOption.label : 'Cash Book';

    //     const customerLabel = selectedAccount?.accountName || 'Cash Book';

    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     // Add header caption
    //     const headerCaption = [
    //         [`Cash Book From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`]
    //     ];
    //     excelData.push(...headerCaption);

    //     // Add column headers
    //     const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
    //     excelData.push(headerRow);

    //     // Add data rows
    //     CashBookilteredData.forEach((rowData) => {
    //         const dataRow = [];
    //         if (rowData.description1 === 'Opening Balance') {
    //             // Display balances under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             );

    //         } else if (rowData.description1 === 'Closing Balance') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         }

    //         else if (rowData.description1 === 'Total') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         } else {
    //             // For regular rows
    //             dataRow.push(
    //                 formatDate(rowData.billdate), // Format the date
    //                 rowData.description1,
    //                 rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
    //                 rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
    //                 computeBalance(rowData) // Compute and add balance
    //             );
    //         }
    //         excelData.push(dataRow);
    //     });

    //     // Create a worksheet
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    //     // Style the worksheet to right-align specific columns
    //     const columnIndexesToRightAlign = [2, 3, 4]; // Debit, Credit, and Balance columns
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);

    //     for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
    //         columnIndexesToRightAlign.forEach((colIndex) => {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
    //             if (worksheet[cellAddress]) {
    //                 worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
    //             }
    //         });
    //     }

    //     // Create workbook and add the worksheet
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Book');

    //     // Filename sanitization for spaces and special characters
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     XLSX.writeFile(workbook, `Cash_Book_From_${formatDate(fromDate).replace(/[/]/g, '-')}_To_${formatDate(toDate).replace(/[/]/g, '-')}.xlsx`);
    // };



    const handleExportLedgerExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Ledger');

        worksheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 2 }]; // Freeze top two rows

        let bal = 0;

        // --- Compute Balance Function ---
        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedAccount?.accountName || 'Ledger';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } },
        };

        // --- Header Title Row ---
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Ledger for ${customerLabel}\nFrom: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
        headerCell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        headerCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF305496' }, // Dark blue header background
        };
        worksheet.getRow(1).height = 30;

        // --- Column Headers ---
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4F81BD' }, // Blue
            };
        });
        worksheet.getRow(2).height = 20;

        // --- Data Rows ---
        CustomerLedgerFilteredData.forEach((rowData, index) => {
            let rowValues;

            if (['Opening Balance', 'Closing Balance', 'Total'].includes(rowData.description1)) {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
                ];
            } else {
                rowValues = [
                    formatDateForInput(rowData.date1),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                ];
            }

            const row = worksheet.addRow(rowValues);

            // --- Alternate Row Shading (Zebra Effect) ---
            if (index % 2 === 0) {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF2F2F2' }, // Light gray
                    };
                });
            }

            // --- Highlight Total or Closing Balance Rows ---
            if (rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFC7CE' }, // Light red
                    };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                });
            } else {
                // Regular row styling
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right', vertical: 'middle' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left', vertical: 'middle' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        // --- Adjust column widths ---
        worksheet.columns = [
            { width: 14 }, // Date
            { width: 40 }, // Description
            { width: 15 }, // Debit
            { width: 15 }, // Credit
            { width: 15 }, // Balance
        ];

        // --- Add bottom padding row ---
        worksheet.addRow([]);
        worksheet.getRow(worksheet.lastRow.number).height = 10;

        // --- Export to file ---
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');

        saveAs(
            new Blob([buffer]),
            `Ledger_${sanitizedCustomerLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    //Customer Ledger  
    const [CashBookmodel, setCashBookmodal] = useState(false);
    const [CashBookilteredData, setCashBookFilteredData] = useState([]);

    const openCashBookmodal = async () => {
        console.log('Opening route data modal');
        //await handlePendingBillClick();
        //handleCustomerLedgerClick();
        setCashBookmodal(true);
    };

    const handleCashBookClick = async (headid, accountName) => {
        setCashBookFilteredData([]); // Clear previous data
        try {
            const response = await fetchData('ReportApi', `/CashBook/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === "1111") {
                setCashBookFilteredData(response.response_data);
                setCashBookmodal(true); // Open modal
                setCustomerLedgerFilteredData([]); // Clear Customer Ledger data if needed
                setCustomerLedgermodal(false);

            } else {
                console.error("Invalid response code:", response.responseCode);
            }
        } catch (error) {
            console.error("Error fetching ledger data:", error);
        }
    };

    const closeCashBookModal = () => {
        console.log('Closing modal');
        setCashBookmodal(false);
    };

    const handleRowClick = (headid, accountName, headName) => {
        if (headName === "Cash In Hand") {
            handleCashBookClick(headid, accountName); // Open CashBook modal
        } else if (
            ["Sundry Creditors", "Sundry Debtors", "Staff", "Income (Direct)", "Expenses (Direct)", "Direct Expenses", "Capital Account"].includes(headName)
        ) {
            handleCustomerLedgerClick(headid, accountName); // Open Ledger modal
        } else {
            console.log("No action required for this headName:", headName);
        }
    };

    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance

    const computeBalance = (data) => {

        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '-10px' }}>
            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '5px' }}>
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '-10px',
                    }}
                >
                    Trial Balance
                </h6>

                {reportGeneratedTime && (
                    <div className="text-sm text-gray-600" style={{ marginTop: '5px', marginRight: '100px' }}>
                        Report Generated: {reportGeneratedTime}
                    </div>
                )}

                {/* <div style={{ flex: '2', maxWidth: '12%', paddingRight: '8px', marginBottom: '0', marginTop: '5px', marginTop: '-10px', }}>
                    <label className="block tracking-wide text-black text-xs mb-2" htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange} style={{ fontSize: '12.5px' }}
                    />
                </div>

                <div style={{ flex: '2', maxWidth: '12%', marginLeft: '8px', marginBottom: '0', marginTop: '5px', marginTop: '-10px', }}>
                    <label className="block tracking-wide text-black text-xs mb-2" htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange} style={{ fontSize: '12.5px' }}
                    />
                </div> */}

                <div className="flex flex-wrap gap-2 items-center">

                    {/* From Date */}
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 text-sm">From</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            className="border border-gray-300 rounded px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                        />
                    </div>

                    {/* To Date */}
                    <div className="flex items-center gap-2">
                        <label className="text-gray-700 text-sm">To</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            className="border border-gray-300 rounded px-2 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                        />
                    </div>

                {/* Buttons */}
                    <Button
                        onClick={fetchTableData}
                        style={{
                            background: "#2f4050",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                            marginLeft: "10px",
                        }}
                    >
                        Refresh
                    </Button>

                    {/* Excel */}
                    <Button
                        onClick={handleExportToExcel}
                        style={{
                            background: "#00695c",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                            marginLeft: "10px",
                        }}
                    >
                        Excel
                    </Button>
                </div>
            </div>

            <div
                className="w-full mb-2 flex"
                style={{ maxHeight: "570px", marginTop: "0.50%" }}
            >
                <TableContainer
                    component={Paper}
                    sx={{
                        borderRadius: "10px",
                        boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
                    }}
                >
                    <Table stickyHeader>

                        {/* Table Head */}
                        <TableHead>
                            <TableRow
                                style={{ backgroundColor: "#3A0519" }}>
                                <TableCell style={{ padding: "5px", fontSize: "12px", fontWeight: "bold", color: "white" }} />
                                <TableCell style={{ padding: "5px", fontSize: "12px", fontWeight: "bold", color: "black", textTransform: "uppercase" }}>
                                    Account Name
                                </TableCell>
                                <TableCell style={{ padding: "5px", fontSize: "12px", fontWeight: "bold", color: "black", textTransform: "uppercase", textAlign: "right" }}>
                                    Debit
                                </TableCell>
                                <TableCell style={{ padding: "5px", fontSize: "12px", fontWeight: "bold", color: "black", textTransform: "uppercase", textAlign: "right" }}>
                                    Credit
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody sx={{ backgroundColor: "#F9FAFB" }}>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                                        Loading data...
                                    </TableCell>
                                </TableRow>
                            ) : filteredDataItem.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                                        No data available
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredDataItem.map((data, index) => {
                                    const isNewHead = index === 0 || data.headName !== filteredDataItem[index - 1].headName;

                                    return (
                                        <React.Fragment key={data.headid}>
                                            {isNewHead && (
                                                <TableRow sx={{ backgroundColor: "#E5E7EB" }}>
                                                    <TableCell
                                                        colSpan={4}
                                                        sx={{ padding: "5px", fontSize: "13px", fontWeight: "bold" }}
                                                    >
                                                        {data.headName}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            <TableRow
                                                onClick={() => handleRowClick(data.headid, data.AccountName, data.headName)}
                                                sx={{
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <TableCell sx={{ padding: "5px", fontSize: "12px", color: "black", fontWeight: "bold" }}>
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        padding: "5px",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        color: data.AccountName === "Hold" ? "red" : "black",
                                                    }}
                                                >
                                                    {data.AccountName}
                                                </TableCell>

                                                <TableCell
                                                    sx={{ padding: "5px", fontSize: "12px", color: "black", textAlign: "right", fontWeight: "bold" }}
                                                >
                                                    {parseFloat(data.TotalDebitSum || 0).toFixed(2)}
                                                </TableCell>

                                                <TableCell
                                                    sx={{ padding: "5px", fontSize: "12px", color: "black", textAlign: "right", fontWeight: "bold" }}
                                                >
                                                    {parseFloat(data.TotalCreditSum || 0).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })
                            )}

                            {/* Totals row */}
                            {!isLoading && filteredDataItem.length > 0 && (
                                (() => {
                                    const totalDebit = filteredDataItem.reduce(
                                        (sum, item) => sum + parseFloat(item.TotalDebitSum || 0),
                                        0
                                    );
                                    const totalCredit = filteredDataItem.reduce(
                                        (sum, item) => sum + parseFloat(item.TotalCreditSum || 0),
                                        0
                                    );

                                    return (
                                        <TableRow
                                            key="totals"
                                            sx={{
                                                backgroundColor: "#D1E7DD",
                                                "&:hover": { backgroundColor: "#C5D8D3" },
                                            }}
                                        >
                                            <TableCell
                                                colSpan={2}
                                                sx={{ padding: "5px", fontSize: "13px", fontWeight: "bold", textAlign: "right" }}
                                            >
                                                Total
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    padding: "5px",
                                                    fontSize: "13px",
                                                    fontWeight: "bold",
                                                    color: "black",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {totalDebit.toFixed(2)}
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    padding: "5px",
                                                    fontSize: "13px",
                                                    fontWeight: "bold",
                                                    color: "black",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {totalCredit.toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })()
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>


                <Modal open={CustomerLedgermodel} onClose={closeCustomerLedgerModal} className={CustomerLedgermodel ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10">
                        <div
                            className="bg-white p-6 rounded-lg shadow-lg"
                            style={{ width: '90%', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto', marginTop: '40px' }}
                        >
                            <div
                                style={{
                                    textAlign: 'left',
                                    fontWeight: 'bold',
                                    color: 'black',
                                    padding: '4px',
                                    fontSize: '14px',
                                    marginTop: '-20px'
                                }}
                            >
                                LEDGER  <span style={{ color: 'darkred', marginLeft: '5px' }}>{selectedAccount?.accountName}</span> {/* Dynamically display the account name */}
                            </div>


                            <div className="flex flex-wrap justify-between items-center mt-2">
                                {/* Date Fields */}
                                <div className="flex w-full md:w-auto justify-center md:justify-start">
                                    {/* From Date */}
                                    <div className="mr-2 max-w-[150px]">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                                            From Date
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            type="date"
                                            value={fromDate}
                                            onChange={handleFromDateChange}
                                        />
                                    </div>

                                    {/* To Date */}
                                    <div className="max-w-[150px]">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                                            To Date
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            type="date"
                                            value={toDate}
                                            onChange={handleToDateChange}
                                        />
                                    </div>
                                </div>

                                {/* Buttons Section */}
                                <div className="flex w-full md:w-auto justify-center md:justify-start mt-2 md:mt-0">
                                    <Button
                                        style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px' }}
                                        onClick={handleCustomerLedgerClick}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>Refresh</span>
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: 'rgb(149, 72, 4)', color: 'white', height: '26px', marginRight: '8px' }}
                                        onClick={handleExportLedgerExcel}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>EXCEL</span>
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: 'rgb(176, 45, 12)', color: 'white', height: '26px' }}
                                        onClick={closeCustomerLedgerModal}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>Close</span>
                                    </Button>
                                </div>
                            </div>

                            {/* Conditionally Render Table or "No Data Found" Message */}
                            <div className='w-full mb-5 flex' style={{ maxHeight: '495px', overflowY: 'auto', marginTop: '5px' }}>
                                {Array.isArray(CustomerLedgerFilteredData) && CustomerLedgerFilteredData.length > 0 ? (
                                    <TableContainer component={Paper}>
                                        <Table stickyHeader>
                                            <TableHead >
                                                <TableRow>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Date</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Description</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Debit</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Credit</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '13px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Balance</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {CustomerLedgerFilteredData.map((data, index) => (
                                                    <TableRow
                                                        key={data.id}
                                                        sx={
                                                            data.description1 === 'Opening Balance'
                                                                ? { backgroundColor: '#CAE0BC' }
                                                                : data.description1 === 'Closing Balance'
                                                                    ? { backgroundColor: '#FFD966' } // Different color for Closing Balance
                                                                    : data.description1 === 'Total'
                                                                        ? { backgroundColor: '#CAE0BC' }
                                                                        : null
                                                        }
                                                    >
                                                        {data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (
                                                            <TableCell sx={{ fontSize: '13px', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                                        ) : (
                                                            <TableCell sx={{ fontSize: '13px', padding: '3px' }}>{formatDateForInput(data.date1)}</TableCell>
                                                        )}

                                                        <TableCell
                                                            sx={{
                                                                fontSize: '13px',
                                                                height: '30px',
                                                                padding: '3px',
                                                                fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal',
                                                            }}
                                                        >
                                                            {data.tbl1 === 'Sale' ? (
                                                                <a href={`/SaleDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'darkgreen' }}>
                                                                    {data.description1}
                                                                </a>
                                                            ) : data.tbl1 === 'Purchase' ? (
                                                                <a href={`/PurchaseDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'darkblue' }}>
                                                                    {data.description1}
                                                                </a>
                                                            ) : data.tbl1 === 'PurchaseReturn' ? (
                                                                <a href={`/PurchaseReturnDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'red' }}>
                                                                    {data.description1}
                                                                </a>
                                                            ) : data.tbl1 === 'SaleReturn' ? (
                                                                <a href={`/SaleReturnDetails/${data.id}`} target="_blank" rel="noopener noreferrer" style={{ color: 'red' }}>
                                                                    {data.description1}
                                                                </a>
                                                            ) : (
                                                                data.description1
                                                            )}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '14px', padding: '3px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}>
                                                            {data.debit != null ? data.debit.toFixed(2) : ''}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: '14px', padding: '3px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}>
                                                            {data.credit != null ? data.credit.toFixed(2) : ''}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                fontSize: '14px',
                                                                height: '30px',
                                                                padding: '5px',
                                                                textAlign: 'right',
                                                                width: '150px',
                                                                fontWeight: 'bolder',
                                                            }}
                                                        >
                                                            {computeBalance(data)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>

                                        </Table>
                                    </TableContainer>

                                ) : (
                                    <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                                        No Data Found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal open={CashBookmodel} onClose={closeCashBookModal} className={CashBookmodel ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10">
                        <div
                            className="bg-white p-6 rounded-lg shadow-lg"
                            style={{ width: '95%', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto', marginTop: '40px' }}
                        >
                            <div
                                style={{
                                    textAlign: 'left',
                                    fontWeight: 'bold',
                                    color: 'black',
                                    padding: '4px',
                                    fontSize: '14px',
                                    marginTop: '-20px'
                                }}
                            >
                                Cash Book
                            </div>


                            <div className="flex flex-wrap justify-between items-center mt-2">
                                {/* Date Fields */}
                                <div className="flex w-full md:w-auto justify-center md:justify-start">
                                    {/* From Date */}
                                    <div className="mr-2 max-w-[150px]">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                                            From Date
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            type="date"
                                            value={fromDate}
                                            onChange={handleFromDateChange}
                                        />
                                    </div>

                                    {/* To Date */}
                                    <div className="max-w-[150px]">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-1">
                                            To Date
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            type="date"
                                            value={toDate}
                                            onChange={handleToDateChange}
                                        />
                                    </div>
                                </div>

                                {/* Buttons Section */}
                                <div className="flex w-full md:w-auto justify-center md:justify-start mt-2 md:mt-0">
                                    <Button
                                        style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px' }}
                                        onClick={handleCashBookClick}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>Refresh</span>
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: 'rgb(149, 72, 4)', color: 'white', height: '26px', marginRight: '8px' }}
                                        onClick={handleExportCashBookExcel}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>EXCEL</span>
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: 'rgb(176, 45, 12)', color: 'white', height: '26px' }}
                                        onClick={closeCashBookModal}
                                        className="linkcolor"
                                    >
                                        <span style={{ fontSize: '11px' }}>Close</span>
                                    </Button>
                                </div>
                            </div>

                            {/* Conditionally Render Table or "No Data Found" Message */}
                            <div className='w-full mb-5 flex' style={{ maxHeight: '650px', overflowY: 'auto' }}>

                                <TableContainer component={Paper}>
                                    <Table stickyHeader>
                                        <TableHead sx={{ backgroundColor: '#27548A' }}>
                                            <TableRow>
                                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', textTransform: 'uppercase', padding: '3px', fontSize: '12px', color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', textTransform: 'uppercase', padding: '3px', fontSize: '12px', color: 'white', fontWeight: 'bold' }}>Description</TableCell>
                                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', textTransform: 'uppercase', padding: '3px', fontSize: '12px', textAlign: 'right', color: 'white', fontWeight: 'bold' }}>Debit</TableCell>
                                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', textTransform: 'uppercase', padding: '3px', fontSize: '12px', textAlign: 'right', color: 'white', fontWeight: 'bold' }}>Credit</TableCell>
                                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', textTransform: 'uppercase', padding: '3px', fontSize: '12px', textAlign: 'right', color: 'white', fontWeight: 'bold' }}>Balance</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {CashBookilteredData.map((data, index) => (
                                                <TableRow key={data.id} sx={data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? { backgroundColor: '#9ACBD0' } : null}>

                                                    {data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (

                                                        <TableCell sx={{ fontSize: '13px', padding: '2px', fontWeight: 'bolder' }}></TableCell>
                                                    ) : (
                                                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{formatDate(data.billdate)}</TableCell>
                                                    )}

                                                    <TableCell sx={{ fontSize: '13px', padding: '2px', }}>{data.description1}</TableCell>
                                                    <TableCell sx={{ fontSize: '13px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                                    <TableCell sx={{ fontSize: '13px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                                    <TableCell
                                                        sx={{
                                                            fontSize: '13px',
                                                            height: '20px',
                                                            padding: '5px',
                                                            textAlign: 'right',
                                                            fontWeight: 'bolder',
                                                        }}
                                                    >
                                                        {computeBalance(data)}
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div >
    );
}

export default TrialBalanceReport;
